export class APIRoutes {

  //----------------------------------------------------------------------
  /* CHANNELS  */

  // Retrieves all the channels in the database
  public static Channels_List = '/channels/list';

  // Retrieved a specific channel
  public static Channels_Get = '/channels/get';

  // Used to create a new channel
  public static Channels_Create = '/channels/create';

  // Used to update an existing channel
  public static Channels_Update = '/channels/update';

  // Used to delete an existing channel
  public static Channels_Delete = '/channels/delete';

  // Connect a catalog to a channel
  public static Channels_AssignCatalog = '/channels/assign-catalog';

  // Connect a catalog to channels
  public static Channels_AssignCatalogs = '/channels/assign-catalogs';

  // Remove the connection between a catalog and a channel
  public static Channels_UnassignCatalog = '/channels/unassign-catalog';

  // Remove the connection between a channel and one or more catalogs
  public static Channels_UnassignCatalogs = '/channels/unassign-catalogs';

  // Create a deliverable of a catalog for a specific channel
  public static Channels_CreateDeliverable = '/channels/create-deliverable';

  // Get all the channels that have the specified catalogs
  public static Channels_GetReferencingCatalogs = '/channels/get-referencing-catalogs';

  // It should trigger the middleware to import the channels
  public static Channels_TriggerMiddlewareImportChannels = '/channels/trigger-middleware-import-channels';

  // Used to import a channel from some external source
  public static Channels_Import = '/channels/import';

  //----------------------------------------------------------------------
  /* CATALOGS  */

  // Retrieves all the catalogs in the database
  public static Catalogs_List = '/catalogs/list';

  // Retrieves a specific catalog
  public static Catalogs_Get = '/catalogs/get';

  // Retrieves a specific catalog by key
  public static Catalogs_Get_By_Key = '/catalogs/get-by-key';

  // Used to update an existing catalog
  public static Catalogs_Update = '/catalogs/update';

  // Used to delete an existing catalog
  public static Catalogs_Delete = '/catalogs/delete';

  // Used to upload a file with a catalog inside
  public static Catalogs_Upload = '/catalogs/upload';

  // Used to upload a file with a catalog inside
  public static Catalogs_Prices_Upload = '/catalogs/upload-prices';

  // Used to upload a file with a catalog inside
  public static Catalogs_Prices_Download = '/catalogs/download-prices';
  //----------------------------------------------------------------------
  /* ORDERS  */

  // Retrieves all the orders in the database
  public static Orders_List = '/orders/list';

  // Retrieves a specific order
  public static Orders_Get = '/orders/get';

  // Used to upload a file that represents an order
  public static Orders_Upload = '/orders/upload';

  // Retrieves a specific order
  public static Orders_Validate = '/orders/validate';

  // Retrieves a specific order
  public static Orders_Send = '/orders/send';

  // Retrieves a specific order
  public static Orders_SendProduction = '/orders/send-production';

  // Retrieves the production order
  public static Orders_GetProductionOrder = '/orders/get-production-order';

  // Updates the orders
  public static Orders_UpdateOrders = '/orders/update-orders';

  // Inserts a new order coming from POS
  public static Orders_InsertOrder = '/orders/insert-order';

  // Inserts a new screenshot of an object that got added to the order
  public static Orders_Screenshot_Insert = '/orders/insert-screenshot';

  // Generate Check code and send email with code
  public static Orders_VerificationCode = '/orders/verification-code';

  //----------------------------------------------------------------------
  /* USERS  */

  // Attempts to authenticate a catalog viewer
  public static Users_Catalog_Login = '/users/catalog-login';

  // Attempts to reset the channel password
  public static Users_Channel_Password_Reset = '/users/channel-password-reset';

  // Attempts to change the channel password
  public static Users_Channel_Password_Change = '/users/channel-password-change';

  // Attempts to validate the credential of the user in the PDM
  public static Users_Login = '/users/login';

  // Check if the token given by the client is still valid
  public static Users_CheckSessionValid = '/users/checkSession';

  // Test Connection to PDM Server
  public static Users_PDMServerCredentialsTest = '/users/pdmserver_credentials-test';

  //----------------------------------------------------------------------
  /* CUSTOM ATTRIBUTES  */

  // Retrieves all the custom attributes in the database
  public static CustomAttributes_List = '/custom-attributes/list';

  // Retrieves a specific custom attribute
  public static CustomAttributes_Get = '/custom-attributes/get';

  // Used to update an existing custom attribute
  public static CustomAttributes_Create = '/custom-attributes/create';

  // Used to update an existing custom attribute
  public static CustomAttributes_Update = '/custom-attributes/update';

  // Used to delete an existing custom attribute
  public static CustomAttributes_Delete = '/custom-attributes/delete';

  // Used to add translations to existing custom attributes
  public static CustomAttributes_Add_Translation = '/custom-attributes/add/translations';

  // Used to get translations to existing custom attributes
  public static CustomAttributes_Get_Translation = '/custom-attributes/get/translations';

  //----------------------------------------------------------------------
  /* CUSTOM ATTRIBUTES LIST  */

  // Retrieves all the custom attributes in the database
  public static CustomAttributeLists_List = '/custom-attribute-lists/list';

  // Retrieves a specific custom attribute
  public static CustomAttributeLists_Get = '/custom-attribute-lists/get';

  // Used to update an existing custom attribute
  public static CustomAttributeLists_Create = '/custom-attribute-lists/create';

  // Used to update an existing custom attribute
  public static CustomAttributeLists_Update = '/custom-attribute-lists/update';

  // Used to delete an existing custom attribute
  public static CustomAttributeLists_Delete = '/custom-attribute-lists/delete';

  //----------------------------------------------------------------------
  /* DEFAULT CHANNEL VALUES */
  public static DefaultChannelValues_Get = '/default-channel-values/get';

  // Used to update an existing custom attribute
  public static DefaultChannelValues_Update = '/default-channel-values/update';

  //----------------------------------------------------------------------
  /* INTEGRATIONS CONFIG */

  // Get the integrations config
  public static IntegrationsConfig_Get = '/integrations-config/get';

  // Update the integrations config
  public static IntegrationsConfig_Update = '/integrations-config/update';

  //----------------------------------------------------------------------
  /* WebServer CONFIG */

  // Get the testbed wbeserver config
  public static WebServerConfig_Get = '/webserver-config/get';

  // Update the testbed webserver config
  public static WebServerConfig_Update = '/webserver-config/update';

  //----------------------------------------------------------------------
  /* PDM  */

  // Get the version and license information
  public static PDMCode_Get_Version_Information = '/pdmCore/version';

  //----------------------------------------------------------------------
  /* General Information  */
  public static General_GetCatalogBuilderClientAddress = '/general/getCatalogBuilderClientAddress';
  public static General_CheckAlive = '/general/check-alive';

  //----------------------------------------------------------------------
  /* PASSWD  */

  // List all users
  public static Passwd_Get_Users = '/passwd/get';

  // Create a user
  public static Passwd_Create_User = '/passwd/create-user';

  // Delete a user
  public static Passwd_Delete_User = '/passwd/delete-user';

  // Update a user
  public static Passwd_Update_User_Group = '/passwd/update-user-group';

  // Update a user passwd
  public static Passwd_Update_User_Passwd = '/passwd/update-user-passwd';

}
